
// Configuration MTCaptcha
export const MTCAPTCHA_CONFIG = {
  // Votre clé de site MTCaptcha
  SITE_KEY: 'MTPublic-23Zc6mDcG',
  
  // CORRECTION: Utiliser 'overcast' qui est le thème sombre valide
  THEME: 'overcast' as const,
  
  // Taille du widget
  SIZE: 'normal' as const
} as const;
